webpackJsonp([36829835628245],{

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReasonReact = __webpack_require__(5);
	
	var component = ReasonReact.statelessComponent("Imprint");
	
	function ste(prim) {
	  return prim;
	}
	
	function make() {
	  return (/* record */[
	    /* debugName */component[/* debugName */0],
	    /* reactClassInternal */component[/* reactClassInternal */1],
	    /* handedOffState */component[/* handedOffState */2],
	    /* willReceiveProps */component[/* willReceiveProps */3],
	    /* didMount */component[/* didMount */4],
	    /* didUpdate */component[/* didUpdate */5],
	    /* willUnmount */component[/* willUnmount */6],
	    /* willUpdate */component[/* willUpdate */7],
	    /* shouldUpdate */component[/* shouldUpdate */8],
	    /* render */function () {
	      return React.createElement("div", undefined, React.createElement("h1", undefined, "Imprint"), React.createElement("h2", undefined, "Nikolaus Graf"), React.createElement("p", undefined, "Johann Knoll Gasse 9, 1210 Vienna, Austria"), React.createElement("p", undefined, React.createElement("a", {
	        href: "mailto:nik@reason-conf.com"
	      }, "nik@reason-conf.com")));
	    },
	    /* initialState */component[/* initialState */10],
	    /* retainedProps */component[/* retainedProps */11],
	    /* reducer */component[/* reducer */12],
	    /* subscriptions */component[/* subscriptions */13],
	    /* jsElementWrapped */component[/* jsElementWrapped */14]]
	  );
	}
	
	var $$default = ReasonReact.wrapReasonForJs(component, function () {
	  return make( /* array */[]);
	});
	
	exports.component = component;
	exports.ste = ste;
	exports.make = make;
	exports.$$default = $$default;
	exports.default = $$default;
	exports.__esModule = true;
	/* component Not a pure module */

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-imprint-js-d5e8a856894ee8ce870d.js